module.exports = __webpack_public_path__ + "static/media/Fidelius_Finalized_Logo_Parts-01.665646e9.svg";